<script>
import { SCRIPTS } from '@events/constant'
import { format, parseISO } from 'date-fns/fp'

export default {
  name: 'AddToCalendar',
  props: {
    event: {
      type: Object,
      required: true,
    },
    joinedTheWaitlist: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    isLoaded: false,
  }),
  computed: {
    eventLocation() {
      const event = this.event
      return `${event.address_1} ${event.address_2} ${event.city}, ${event.state} ${event.zip}`
    },
  },
  created() {
    this.$loadScript(SCRIPTS.addToCalendar)
      .then(() => {
        this.isLoaded = true
      })
      .catch(() => alert('Something went wrong.'))
  },
  methods: {
    formatDate(date) {
      format('yyyy-MM-dd HH:mm:ss', parseISO(date))
    },
  },
}
</script>

<template>
  <BaseModalWindow
    modalcls="w-full max-w-1.95xl bg-white rounded-xl mx-auto px-10 py-8 shadow-box relative left-0"
    :visible="true"
    @close="$emit('close')"
  >
    <template v-slot:body>
      <h3
        v-if="!joinedTheWaitlist"
        class="block pb-6 italic font-brandon text-blue-darker text-35xl"
      >
        REGISTRATION CONFIRMATION
      </h3>
      <h3
        v-if="joinedTheWaitlist"
        class="block pb-6 italic font-brandon text-blue-darker text-35xl"
      >
        WAITLIST CONFIRMATION
      </h3>
      <div class="flex flex-col items-start space-y-4">
        <p v-if="!joinedTheWaitlist">You are registered for {{ event.name }}</p>
        <p v-if="joinedTheWaitlist"
          >You are on the waitlist for {{ event.name }}</p
        >

        <div v-if="isLoaded" title="Add to Calendar" class="addeventatc">
          Add to Calendar
          <span class="start" v-text="formatDate(event.start)" />
          <span class="end" v-text="formatDate(event.end)" />
          <span
            v-if="event.timezone"
            class="timezone"
            v-text="event.timezone"
          />
          <span v-else class="timezone" v-text="'America/Denver'" />
          <span class="title" v-text="event.name" />
          <span class="description" v-text="event.details" />
          <span class="location" v-text="eventLocation" />
        </div>
      </div>
    </template>
  </BaseModalWindow>
</template>
